export default "__VITE_ASSET__DwwoLtVh__"